import { useContext } from "react";
import { HashRouter as Router, Route, Routes, Navigate } from "react-router-dom";

//Se importan vistas
import Login from "./views/Login/login";
import Dashboard from "./views/Dashboard/dashboard";

import PrintView from "./views/printView.jsx";
import DocumentoVisorPrint from "./views/printDocumentos.jsx";
import SplashScreen from "./views/Splash/SplashScreen.jsx";

//Context
import typeScriptContext from "./AppState/SystemConfig/appContext";

//Styles and global animations
import "./animations.css";
import "./styles/_main.scss";
import QrAccess from "./Global Components/utils/qrAccess";
import AuthEntry from "./Global Components/utils/auth-entry.jsx";
import PDFViewer from "./views/Login/components/PoliticaTratamientoDeDatos/PDF.jsx";

function App() {
  const { AppManager } = useContext(typeScriptContext);

  const Private = ({ Component }) => {
    let authenticated = false;

    if (AppManager.userToken != null) {
      authenticated = true;
    } else if (AppManager.companyToken != null) {
      authenticated = true;
    }

    return authenticated ? <Component /> : <Navigate to="/login" />;
  };

  return (
    <Router basename="/">
      {/* // Declaracion de rutas y renderizado de paginas  */}
      <Routes>
        <Route exact path="/" element={<Private Component={Dashboard} />} />
        <Route path="/dashboard" element={<Private Component={Dashboard} />} />

        <Route exact path="/Qrlogin" element={<QrAccess />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/login/validate" element={<AuthEntry />} />

        <Route path="/pdf" element={<PrintView></PrintView>} />
        <Route path="/politica" element={<PDFViewer />} />
        <Route path="/docprint" element={<DocumentoVisorPrint />} />
        <Route path="/loading" element={<SplashScreen></SplashScreen>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
